import NOT_PRINTABLE_KEYS from '../dom/notPrintableKeys';

/**
 * @private
 * Determines whether the key pressed is not printable (in `keydown` event)
 *
 * @param {Number} keyCode - the key pressed
 * @return {Boolean}
 */
function isNotPrintableKey(keyCode) {
  for (const char in NOT_PRINTABLE_KEYS) {
    if (NOT_PRINTABLE_KEYS[char] === keyCode) return true;
  }
  return false;
}

/**
 * Event handler for the `keydown` event when typing an address.
 *
 * @param {Event} evt - the event triggered
 * @return {void}
 */
export default function onKeydown(evt) {
  const key = evt.charCode || evt.which || evt.keyCode;
  // counts the characters in the autocomplete box
  let chars = evt.target.value.length + (+!isNotPrintableKey(key));
  if (key === NOT_PRINTABLE_KEYS.backspace) chars -= 1;
  // prevent submitting the form
  if (key === NOT_PRINTABLE_KEYS.enter) evt.preventDefault();
  // prevent start a search in the autocomplete box
  if (chars < 3) evt.stopImmediatePropagation();
}
